import React from 'react';

import { SharedAppShell } from '~/components/layouts/SharedAppShell';
import { PatientDetailDialog } from '~/components/partials';
import { AnnounceOrganizationBusinessHourModal } from '~/components/partials/AnnounceOrganizationBusinessHourModal';
import { useFeatureFlag } from '~/hooks/use-feature-flag';

import { RootMenu } from './RootMenu';

type Props = { children?: React.ReactNode };

const OrganizationAppShell: React.FC<Props> = ({ children }) => {
  const disableAnnounceModal = useFeatureFlag(
    'Issue11803-disable_announce_organization_business_hour_modal',
  );

  return (
    <SharedAppShell>
      <SharedAppShell.SideMenu>
        <RootMenu />
      </SharedAppShell.SideMenu>
      <SharedAppShell.Content>
        {children}
        <PatientDetailDialog />
        {!disableAnnounceModal && <AnnounceOrganizationBusinessHourModal />}
      </SharedAppShell.Content>
    </SharedAppShell>
  );
};

export { OrganizationAppShell };
